import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../components/modal/confirmdialog/confirmdialog.component';

@Injectable({ providedIn: 'root' })
export class AllowanceFundingFeedbackService {
  constructor(private readonly dialog: MatDialog) {}

  async report<T>(response: T): Promise<T> {
    const funding = (response as any)?.allowanceFunding;
    if (funding && !['scheduled', 'paused', 'disabled', 'legacy'].includes(funding.status)) {
      // Use fixed UI text: the existing confirmation component renders HTML.
      const message = ['pending', 'recovery_pending'].includes(funding.status)
        ? 'Your settings were saved. Monthly allowance funding is still updating. Check the funding status before retrying.'
        : funding.status === 'setup_required'
          ? 'Your settings were saved. Open allowance funding to check the default funding method, complete any verification, and review initial member funding.'
          : funding.status === 'recovery_required'
            ? 'Your settings were saved, but recurring funding is missing. Open allowance funding to review the available recovery action and its next payment date.'
          : 'Your settings were saved, but the monthly allowance funding update needs attention. Open allowance funding to review its status before retrying.';
      await this.dialog.open(ConfirmDialogComponent, {
        data: new ConfirmDialogModel('Allowance funding needs attention', message, true),
      }).afterClosed().toPromise();
    }
    return response;
  }
}
